import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';
import { getItemTotalWeight } from './weightSummary';

const EtcForm = ({ etc, size, floors, cladding, stair, openings, hoistBeam }) => {
    const dispatch = useDispatch();

    const [newETC, setNewETC] = useState(etc || {});

    /* 내부 계산 */
    useEffect(() => {
        const mainWeight =
            getItemTotalWeight(size) +
            getItemTotalWeight(floors) +
            getItemTotalWeight(cladding) +
            getItemTotalWeight(stair) +
            getItemTotalWeight(openings) +
            getItemTotalWeight(hoistBeam);

        setNewETC({
            etcWeight: Math.ceil(mainWeight * 0.03) || '',
            fastenerWeight: Math.ceil(mainWeight * 0.02) || '',
            anchorWeight: Math.ceil(mainWeight * 0.01) || '',
        });
    }, [cladding, floors, hoistBeam, openings, size, stair]);

    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {
        dispatch(
            summaryWeight({
                key: 'etc',
                value: newETC.etcWeight,
            }),
        );
        dispatch(
            summaryWeight({
                key: 'fastener',
                value: newETC.fastenerWeight,
            }),
        );
        dispatch(
            summaryWeight({
                key: 'anchor',
                value: newETC.anchorWeight,
            }),
        );
    }, [dispatch, newETC.anchorWeight, newETC.etcWeight, newETC.fastenerWeight]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'etc',
                value: newETC,
            }),
        );
    }, [dispatch, newETC]);

    return (
        <>
            <tr>
                <td>H.T.Bolt / Nut</td>
                <td colSpan={3}>
                    <span className="sub-description">2% of Main Weight</span>
                </td>
                <td className="right-align">1</td>
                <td>lot</td>
                <td className="right-align">-</td>
                <td className="right-align">{newETC.fastenerWeight}</td>
            </tr>
            <tr>
                <td>Anchor, Fixtures</td>
                <td colSpan={3}>
                    <span className="sub-description">1% of Main Weight</span>
                </td>
                <td className="right-align">1</td>
                <td>lot</td>
                <td className="right-align">-</td>
                <td className="right-align">{newETC.anchorWeight}</td>
            </tr>
            <tr>
                <td>Etc.(Contingency)</td>
                <td colSpan={3}>
                    <span className="sub-description">3% of Main Weight</span>
                </td>
                <td className="right-align">1</td>
                <td>lot</td>
                <td className="right-align">-</td>
                <td className="right-align">{newETC.etcWeight}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default EtcForm;
